/* eslint-disable class-methods-use-this */
import {type TranslationObject} from '@colonist/i18n'
import {type SocketDataTypes} from '../../../../shared/SocketDataTypes.ts'
import {type LobbyImage} from '@colonist/types'
import {UINotificationController, type UITopNotificationType} from '../../../shared/scripts/notifications/UINotificationController.ts'
import {UICornerNotificationController} from '../ui_corner_notification/UICornerNotificationController.ts'
import {UITopNotificationController} from '../ui_top_notification/UITopNotificationController.ts'
import {NotificationContentType} from '../../../shared/scripts/ui_utils/NotificationUtils.ts'

export class UIWNotificationController extends UINotificationController {
    show(text: TranslationObject, type: UITopNotificationType, buttonText?: TranslationObject, action?: (() => void) | undefined, removeAction?: (() => void) | undefined, showCloseButton: boolean = true, duration?: number) {
        UITopNotificationController.show(text, type, buttonText, action, removeAction, showCloseButton, duration)
    }
    showNotification(icon: LobbyImage, text: TranslationObject, duration?: number, action?: () => void, removeAction?: () => void, contentType: NotificationContentType = NotificationContentType.General) {
        UICornerNotificationController.showNotification(icon, text, duration, action, removeAction, undefined, contentType)
    }
    showGames(games: SocketDataTypes.UserGamesData[]) {
        UITopNotificationController.showGames(games)
    }
    removeDisconnectBanners() {
        UITopNotificationController.removeDisconnectBanners()
    }
    removeSocketErrorBanners() {
        UITopNotificationController.removeSocketErrorBanners()
    }
}

